export default "\u002Fassets\u002Flogo-official-d157ca60.webp"